import { LocalNotifications } from "@capacitor/local-notifications";

export async function throwLocalNotifications({path, name, body, isEkkko}) {
  const options = {
    notifications: [
      {
        title: name,
        body,
        id: new Date().getUTCMilliseconds(),
        smallIcon: isEkkko ? 'ekkko_notification_icons': 'ic_stat_name.png',
        attachments: [
          {
            id: new Date().getUTCMilliseconds(),
            url: 'file://' + path,
            options: null,
          }
        ]
      }
    ]
  };
  await LocalNotifications.schedule(options);
}

/**
 * Enhanced notification helper for background uploads
 */
export async function scheduleBackgroundUploadNotification({
  title,
  body,
  id,
  category = 'upload',
  isEkkko = false
}) {
  try {
    // Check if we're in a web environment
    if (typeof window !== 'undefined' && !window.Capacitor) {
      console.log('Notifications not supported in web environment');
      return false;
    }

    // Gracefully check permissions without throwing errors
    let permissionStatus;
    try {
      permissionStatus = await LocalNotifications.checkPermissions();
    } catch (error) {
      console.warn('Cannot check notification permissions:', error.message);
      return false;
    }

    // Only request permissions if not already determined
    if (permissionStatus.display === 'prompt') {
      try {
        const requestResult = await LocalNotifications.requestPermissions();
        if (requestResult.display !== 'granted') {
          console.log('Notification permissions denied by user');
          return false;
        }
        permissionStatus = requestResult;
      } catch (error) {
        console.warn('Failed to request notification permissions:', error.message);
        return false;
      }
    }

    // If permissions are denied, don't attempt to schedule
    if (permissionStatus.display !== 'granted') {
      console.log('Notification permissions not granted, skipping notification');
      return false;
    }

    const notification = {
      title,
      body,
      id: id || new Date().getUTCMilliseconds(),
      smallIcon: isEkkko ? 'ekkko_notification_icons' : 'ic_stat_name.png',
      schedule: { at: new Date(Date.now() + 100) }, // Small delay
      sound: 'default',
      attachments: [],
      actionTypeId: '',
      extra: {
        category
      }
    };

    await LocalNotifications.schedule({
      notifications: [notification]
    });

    return true;
  } catch (error) {
    console.warn('Failed to schedule notification:', error.message);
    return false;
  }
}

/**
 * Clear all notifications for background uploads
 */
export async function clearBackgroundUploadNotifications() {
  try {
    const delivered = await LocalNotifications.getDeliveredNotifications();
    const uploadNotifications = delivered.notifications.filter(
      n => n.extra?.category?.includes('upload')
    );
    
    if (uploadNotifications.length > 0) {
      await LocalNotifications.removeDeliveredNotifications({
        notifications: uploadNotifications
      });
    }
  } catch (error) {
    console.warn('Failed to clear upload notifications:', error);
  }
}
